var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-xl-row justify-content-between"},[_vm._t("default"),_c('div',{staticClass:"mb-3 mb-xl-0 mr-xl-1",class:{'flex-grow-1': _vm.flexGrow}},[_vm._t("left")],2),_c('div',{staticClass:"d-flex justify-content-end align-items-center"},[_vm._t("right")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }